// the Gatsby Chakrau UI requires a theme.js, so we import from the theme.ts
import theme from './theme.ts'
export default theme